import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { Finishing } from 'src/app/shared-lib/core/settings';
import { ProductService } from 'src/app/shared-lib/domains/product';
import { AppService } from 'src/app/shared/app.service';
import { CartService } from 'src/app/shared/cart.service';
import { FileService } from 'src/app/shared/file.service';
import { UtilsService } from 'src/app/shared/services/utils.service';


@Component({
  selector: 'app-print-product-modal',
  templateUrl: './print-product-modal.component.html',
  styleUrls: ['./print-product-modal.component.scss'],
  standalone: false
})
export class PrintProductModalComponent implements OnInit {

  @Input() item;
  @Input() inOrderDetail: boolean = false;

  printSettings;
  files: any[] = [];
  withoutStock: { [fileId: string]: { ringColor: boolean, hardCoverFront: boolean, hardCoverBack: boolean; }; } = {};
  finishing = Finishing;
  coverSettings;

  constructor(
    private modalController: ModalController,
    public utils: UtilsService,
    public fileService: FileService,
    private router: Router,
    private menuCtrl: MenuController,
    private productService: ProductService,
    public cartService: CartService,
    protected appService: AppService
  ) { }

  ngOnInit() {
    this.printSettings = this.item?.product?.printingGroup.printSettings;
    this.files = this.item?.product?.printingGroup?.files || [];
    this.coverSettings = this.fileService.getCoverSettings();
  }

  get warningMessage() {
    return this.productService.getWarningMessage(this.item?.product?.printingGroup);
  }

  bindingOptionValue(option, param, file = null) {
    let ret;
    let isGroup = this.printSettings.grouped;
    switch (option) {
      case 'ringColor':
        if (param === 'id')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.ringColor : file.ringColor)?.id;
        if (param === 'name')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.ringColor : file.ringColor)?.name;
        break;
      case 'hardCoverFront':
        if (param === 'id')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverFront : file.hardCoverFront)?.id;
        if (param === 'name')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverFront : file.hardCoverFront)?.name;
        if (param === 'color')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverFront : file.hardCoverFront)?.color;
        break;
      case 'hardCoverBack':
        if (param === 'id')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverBack : file.hardCoverBack)?.id;
        if (param === 'name')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverBack : file.hardCoverBack)?.name;
        if (param === 'color')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverBack : file.hardCoverBack)?.color;
        break;
    }

    return ret;
  }

  getCoverTypeSetting(file) {
    let setting = this.coverSettings.find(setting => setting.value.id === file.coverType.id);
    return setting;
  }

  editPrintProduct() {
    if (this.router.url === '/') {
      this.cartService.setActivePrintItem(this.item);
    } else {
      const navigationExtras: NavigationExtras = { state: { item: this.item } };
      this.router.navigate(["/"], navigationExtras);
    }
    // Close side menu after navigating to home page
    this.menuCtrl.close('cart-preview');
    this.dismiss();
  }

  dismiss() {
    this.modalController.dismiss();
  }

}
